<template>
  <div>
    <transition name="fade">
      <component :is="currentView" @switchView="handleSwitch" />
    </transition>
  </div>
</template>

<script>
import ReportChat from './components/ReportChat.vue'
import ReportForm from './components/ReportForm.vue'

export default {
  name: 'Report',
  components: { ReportChat, ReportForm },
  data() {
    return { currentView: 'ReportChat' }
  },
  methods: {
    handleSwitch(view) {
      this.currentView = view
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
